import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';

interface IPageRc0003 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireLrt: IFormulaire;
    txmMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Rc0003Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    ac0010Route: IRoute) {
    const vm: IPageRc0003 = this;

    const docAchat = [
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            ac0010Route.NAME,
            (data:any) => ({
                id: data.doccleintref
            }),
            { 
                fonction:'BOUDAC',
                icon:'exit_to_app'
            }
        )
    ];

    vm.monoOccurrenceOptions = {
        formulaire: new Formulaire('LBL_BLC_LRT', [
            new FormulaireItem('ltrcod'),
            new FormulaireItem('lrtcodseq'),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('lrtstu'),
            new FormulaireItem('refcleint'),
            new FormulaireItem('intcleintreq')
        ])
    };

    vm.formulaireLrt = new Formulaire([
        new FormulaireItem('ltrnumref'),
        new FormulaireItem('ltrdat'),
        new FormulaireItem('lipcleint'),
        new FormulaireItem('ltrdsc', { largeur: 100 })
    ]);

    vm.txmMultiOccurrenceOptions = {
        bloc: 'txm',
        colonnesFixesGauche: [
            { nom: 'docaffnumdoc01', largeur: 120 }
        ],
        colonnesVisibles: [
            { nom: 'docaffnumdoc01ref', largeur: 150, menu: docAchat },
            { nom: 'peccod', largeur: 100 },
            { nom: 'etddsc', largeur: 150 },
            { nom: 'refcod', largeur: 120 },
            { nom: 'refnom', largeur: 200 },
            { nom: 'intcodreq', largeur: 120 },
            { nom: 'intnomreq', largeur: 200 }
        ],
        colonnesCachees: [ 'doccleintref' ]
    }
}
